import { isRouteErrorResponse, useRouteError } from 'react-router';
import { IRouterErrorBoundaryProps } from '@/types/.component.ts';
import { Result } from 'antd-mobile';
import DefaultLayout from '@/components/layout/DefaultLayout.tsx';

export default function RouterErrorBoundary(props: IRouterErrorBoundaryProps) {
    const { status } = props;
    const error = useRouteError();

    const renderError = () => {
        const err = isRouteErrorResponse(error) ? error.status : status;
        switch (err) {
            case 404:
                return <Result status="warning" title="404" description="找不到当前访问的页面" />;
            default:
                return <Result status="warning" title="警告" description="页面出现了某些错误" />;
        }
    };

    return (
        <DefaultLayout className="bg-white">
            <div className="w-full">{renderError()}</div>
        </DefaultLayout>
    );
}
